import React from 'react';
import * as Types from '@xingternal/pages-graphql-types';

import { Button } from '@xingternal/button';
import { isBrowser } from '@xingternal/hops';
import { SocialBar } from '@xingternal/social-bar';
import { IconMore } from '@xingternal/icons';
import { usePopOver } from '@xingternal/pop-over';
import { URL_SOCIAL_BAR } from '@xingternal/pages-common';

import { NewsItemMenu } from './NewsItemMenu';
import styles from './styles.css';
import { newsPath } from '../utils';

type NewsItemSocialProps = {
  basePath: string;
  isDetailPage: boolean;
  activityGlobalId: any;
  authorUrn: any;
  externalUrl?: any;
  metadata: Types.EntityPageContentFeedMetadata;
  pageSlug: string;
  xbmUrl: string;
};

export const NewsItemSocial = ({
  basePath,
  pageSlug,
  activityGlobalId,
  metadata,
  authorUrn,
  isDetailPage,
  externalUrl = null,
  xbmUrl,
}: NewsItemSocialProps) => {
  const activityId = activityGlobalId.split(':').pop();

  // include back_to parameter to allow startpage to link back to current page
  const detailUrl = `/discover/detail-activities/${activityId}?back_to=${encodeURIComponent(
    `${isDetailPage ? newsPath(basePath, pageSlug) : basePath + '/' + pageSlug}`
  )}`;
  if (!externalUrl && typeof window !== 'undefined') {
    externalUrl = window.location.origin + detailUrl;
  }

  const popOver = usePopOver();
  const flyOut = (
    <div className={styles.action}>
      <Button
        data-testid="flyout-anchor"
        size={'medium'}
        icon={IconMore}
        onClick={popOver.handleShow}
        innerRef={popOver.triggerRef}
        aria-label="More"
      />
    </div>
  );

  const handleCommentClick = () => window.location.assign(detailUrl);

  return (
    <section className={styles.wrapper}>
      {isBrowser && (
        <SocialBar
          urn={activityGlobalId}
          onCommentClick={handleCommentClick}
          url={externalUrl}
          hasShare={metadata.isRecommendable}
          hasReaction={metadata.isLikeable}
          hasComment={metadata.isCommentable}
          shareZenViewTo={URL_SOCIAL_BAR}
          propChannel="wbm/EntityPages"
          entryPoint="entity_page_social_share"
          rightBar={flyOut}
        />
      )}
      <NewsItemMenu
        activityGlobalId={activityGlobalId}
        authorUrn={authorUrn}
        popOver={popOver}
        xbmUrl={xbmUrl}
      />
    </section>
  );
};

export default NewsItemSocial;
